import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAtom } from "jotai";
import {
  emailAtom,
  emailValidAtom,
  resetForgotPasswordCodeAtom,
} from "@/store/atoms";
import { useAuth } from "common/hooks";
import { AuthModalScreen, useAuthModals } from "@/hooks/useAuthModals";
import Loader from "@/components/common/Loader";
import { Helmet } from "react-helmet-async";

export const Route = createFileRoute("/passwordreset/$code/user/$email")({
  component: PasswordReset,
});

function PasswordReset() {
  const navigate = useNavigate({ from: "/" });
  const { isLoading, isFetching, isLoggedIn } = useAuth();
  const isAuthLoading = isLoading || isFetching;
  const { showModal } = useAuthModals();
  const [, setEmail] = useAtom(emailAtom);
  const [, setEmailValid] = useAtom(emailValidAtom);
  const [, setResetForgotPasswordCode] = useAtom(resetForgotPasswordCodeAtom);
  const { code, email } = Route.useParams();

  // Decode the URL-encoded user parameter
  const decodedUserEmail = decodeURIComponent(email);

  useEffect(() => {
    if (isLoggedIn) {
      //redirect to home page
      navigate({ to: "/" });
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (!isLoading && !isFetching && !isLoggedIn && code && decodedUserEmail) {
      setEmail(decodedUserEmail);
      setEmailValid(true);

      setResetForgotPasswordCode(code);
      showModal(AuthModalScreen.ResetForgotPassword);

      //redirect to home page
      navigate({ to: "/" });
    }
  }, [
    code,
    decodedUserEmail,
    isFetching,
    isLoading,
    isLoggedIn,
    navigate,
    setEmail,
    setEmailValid,
    setResetForgotPasswordCode,
    showModal,
  ]);

  return (
    <>
      <Helmet>
        <title>Reset Password - Sociability</title>
      </Helmet>
      {isAuthLoading && <Loader />}
    </>
  );
}
